import {
  createApiReducer,
  chainReducers,
  INITIAL_API_STATUS,
} from 'services/api';
import {
  AdvancedSearchItem,
  createAddSearchReducer,
  createDeleteSearchReducer,
  createFetchSearchReducer,
  createUpdateSearchReducer,
} from 'services/search';
import { combineReducers } from 'redux';

import { PaymentTermsActionTypes } from './actions';
import { transformPaymentTerm } from '../transformations';

const initialState = {
  _status: INITIAL_API_STATUS,
  items: [],
};

/**
 * Transforms search item received from server to our format
 * @param response
 */
export const transformSearch = (serverSearchItem: any): AdvancedSearchItem => {
  return {
    id: serverSearchItem.id,
    columns: serverSearchItem.columns,
    searchName: serverSearchItem.searchName,
    isDefault: serverSearchItem.isDefault,
  };
};

const customerRatesReducer = createApiReducer(
  [
    PaymentTermsActionTypes.FETCH_PAYMENT_TERMS_START,
    PaymentTermsActionTypes.FETCH_PAYMENT_TERMS_SUCCESS,
    PaymentTermsActionTypes.FETCH_PAYMENT_TERMS_FAILURE,
  ],
  (data) => ({ items: data.results.map(transformPaymentTerm) }),
  (data) => data
);

const fetchSearchReducer = createFetchSearchReducer('paymentTerms');
const addSearchReducer = createAddSearchReducer('paymentTerms');
const updateSearchReducer = createUpdateSearchReducer('paymentTerms');
const deleteSearchReducer = createDeleteSearchReducer('paymentTerms');

const customerChainedReducers = chainReducers(
  initialState,
  customerRatesReducer
);

const searchChainedReducers = chainReducers(
  initialState,
  fetchSearchReducer,
  addSearchReducer,
  updateSearchReducer,
  deleteSearchReducer
);

export default combineReducers({
  paymentTerms: customerChainedReducers,
  searches: searchChainedReducers,
});
